import { render, staticRenderFns } from "./PrimaryNavItem.vue?vue&type=template&id=626fef3b"
import script from "./PrimaryNavItem.vue?vue&type=script&lang=js"
export * from "./PrimaryNavItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports